import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import { inject, onMounted } from 'vue'
import { useRouter } from 'vue-router'

import { Mixpanel } from '@/analytics/mixpanel'
import type { ListView } from '@/models/docs.list'
import type { ListItem } from '@/models/interfaces'
import { Sentry } from '@/services/sentry'
import { playerSession } from '@/services/player'

import ListingBlockLayout from './ListingBlockLayout.vue'
import ListCard from './ListCard.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ListingBlock',
  props: {
    view: {},
    docs: {},
    cardProps: {},
    docViewEventProperties: { type: Function }
  },
  setup(__props: any) {

const props = __props

const router = useRouter()

// Discover.vue provides this callback, so when in Discover the ListingBlocks
// call it and register the docs in their list.
const registerDiscoverListingBlock = inject<
  ((title: string, docTitles: string[]) => void) | undefined
>('registerDiscoverListingBlock', undefined)

onMounted(() => {
  registerDiscoverListingBlock?.(
    props.view.pageTitle(),
    props.docs.map((doc) => doc.title),
  )
})

function trackDocView(event: Event, doc: ListItem): void {
  try {
    playerSession.value.setNextArrival('card')
    Mixpanel.trackDocView(
      event,
      props.view.pageTitle(),
      router.currentRoute.value.fullPath,
      doc,
      props.docViewEventProperties?.(doc),
    )
  } catch (error: any) {
    // Unexpected error in the Mixpanel tracking
    Sentry.captureException(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListingBlockLayout, {
    class: _normalizeClass(`listing-block--${__props.view.cssClassModifier}`),
    title: __props.view.pageTitle(),
    viewAllLink: __props.view.viewAllLink,
    viewAllText: __props.view.viewAllText,
    viewAllQuery: __props.view.viewAllQuery,
    isEmpty: __props.docs.length == 0
  }, _createSlots({
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.docs, (doc) => {
        return (_openBlock(), _createBlock(ListCard, _mergeProps({
          key: doc.id,
          view: __props.view,
          doc: doc
        }, { ref_for: true }, __props.cardProps, {
          onClick: ($event: any) => (trackDocView($event, doc))
        }), null, 16, ["view", "doc", "onClick"]))
      }), 128))
    ]),
    _: 2
  }, [
    (_ctx.$slots.headerActions)
      ? {
          name: "headerActions",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "headerActions")
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["class", "title", "viewAllLink", "viewAllText", "viewAllQuery", "isEmpty"]))
}
}

})